import { add_gaps, make_staircase, normalize_time, time_mul_1k, } from './common';
import { BooleanMarkingsGraphSource, GraphSource, TemperatureGraphData } from './base';
import { ZTCStateFlags } from './data-types';
import { LoadDataType } from '../load-types';
import * as cf from 'console/tabs/graphs/components/graph/sources/common';
const colors = ['#e50000', '#16a0e5', '#e55bce', '#e58900', '#00d600'];
const GSMState = {
    not_registered: 0,
    home_network: 1,
    searching: 2,
    rejected: 3,
    roaming: 5,
};
export class ZTCTempGraphSource extends TemperatureGraphData {
    static assignment2title = {
        engine: 'температура двигателя',
        cabin: 'температура в салоне',
        outside: 'температура снаружи',
    };
    temp_no;
    _title;
    class_name() {
        return 'ZTCTempGraphSource';
    }
    constructor(device, { temp_no, color, }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.temp_no = temp_no;
        const assignment = device.temperature_conf()?.assignments?.[this.temp_no];
        this._color = color;
        this._title =
            assignment != null && assignment !== 'none'
                ? ZTCTempGraphSource.assignment2title[assignment]
                : `термодатчик №${this.temp_no + 1}`;
    }
    serialize_params() {
        return { temp_no: this.temp_no, color: this._color };
    }
    is_same(other) {
        return this.constructor === other.constructor && this.temp_no === other.temp_no;
    }
    title() {
        return this._title;
    }
    color() {
        if (this._color)
            return this._color;
        return colors[this.temp_no];
    }
    show_in_legend(data) {
        return data?.length > 0;
    }
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    extract_data(raw_data) {
        return raw_data?.temperature?.[this.temp_no];
    }
}
export class ZTCGSMLevelGraphSource extends GraphSource {
    class_name() {
        return 'ZTCGSMLevelGraphSource';
    }
    title() {
        return 'уровень сигнала';
    }
    color() {
        if (this._color)
            return this._color;
        return '#00a889';
    }
    yaxis_key() {
        return 'percent-0-100';
    }
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    extract_data(raw_data) {
        return raw_data?.gsm_level;
    }
    normalize_data(data) {
        data = make_staircase(time_mul_1k(normalize_time(data, 0)), 60e3);
        for (const item of data)
            item[1] = this._convert_to_percent(item[1]);
        return data;
    }
    _convert_to_percent(level) {
        return (level * 100) / 31;
    }
}
export class ZTCGSMBalanceGraphSource extends GraphSource {
    class_name() {
        return 'ZTCGSMBalanceGraphSource';
    }
    title() {
        return 'баланс';
    }
    color() {
        if (this._color)
            return this._color;
        return '#a05be5';
    }
    yaxis_key() {
        return 'balance';
    }
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    extract_data(raw_data) {
        return raw_data?.gsm_balance;
    }
    normalize_data(data) {
        return make_staircase(time_mul_1k(normalize_time(data, 0)), 60e3);
    }
}
export class ZTCVoltageGraphSource extends GraphSource {
    class_name() {
        return 'ZTCVoltageGraphSource';
    }
    title() {
        return 'напряжение питания';
    }
    color() {
        if (this._color)
            return this._color;
        return '#c49100';
    }
    yaxis_key() {
        return 'voltage';
    }
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    extract_data(raw_data) {
        return raw_data?.voltage;
    }
    normalize_data(data) {
        return make_staircase(time_mul_1k(normalize_time(data, 0)), 60e3);
    }
}
const ZTCGSMStateGraphSource = class extends BooleanMarkingsGraphSource {
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    normalize_data(data) {
        return normalize_time(data, 0);
    }
};
export class ZTCGSMState_HomeNetwork extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCGSMState_HomeNetwork';
    }
    title() {
        return 'домашняя сеть';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(0,229,0,0.4)';
    }
    predicate(value) {
        return value === GSMState.home_network;
    }
    extract_data(raw_data) {
        return raw_data?.gsm_state;
    }
}
export class ZTCGSMState_Searching extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCGSMState_Searching';
    }
    title() {
        return 'поиск сигнала';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,200,0,0.4)';
    }
    predicate(value) {
        return [GSMState.not_registered, GSMState.searching].includes(value);
    }
    extract_data(raw_data) {
        return raw_data?.gsm_state;
    }
}
export class ZTCGSMState_Rejected extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCGSMState_Rejected';
    }
    title() {
        return 'отказ сети';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,0,0,0.4)';
    }
    predicate(value) {
        return value === GSMState.rejected;
    }
    extract_data(raw_data) {
        return raw_data?.gsm_state;
    }
}
export class ZTCGSMState_Roaming extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCGSMState_Roaming';
    }
    title() {
        return 'роуминг';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(0,229,189,0.4)';
    }
    predicate(value) {
        return value === GSMState.roaming;
    }
    extract_data(raw_data) {
        return raw_data?.gsm_state;
    }
}
export class ZTCConnectionState_MainPower extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCConnectionState_MainPower';
    }
    title() {
        return 'Основное питание';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(26,211,13,0.83)';
    }
    predicate(value) {
        return (value & ZTCStateFlags.MAIN_POWER) != 0;
    }
    // @ts-ignore
    extract_data(raw_data) {
        return raw_data?.status_flags;
    }
}
export class ZTCConnectionState_SupplyPower extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCConnectionState_SupplyPower';
    }
    title() {
        return 'Резервное питание';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(231,29,10,0.83)';
    }
    predicate(value) {
        return (value & ZTCStateFlags.MAIN_POWER) == 0;
    }
    // @ts-ignore
    extract_data(raw_data) {
        return raw_data?.status_flags;
    }
}
export class ZTCConnectionState_GSM extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCConnectionState_GSM';
    }
    title() {
        return 'Подключение GSM';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(211,179,13,0.83)';
    }
    predicate(value) {
        return (value & ZTCStateFlags.CONNECTION_VIA_GSM) != 0;
    }
    // @ts-ignore
    extract_data(raw_data) {
        return raw_data?.status_flags;
    }
}
export class ZTCConnectionState_WiFi extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCConnectionState_WiFi';
    }
    title() {
        return 'Подключение WiFi';
    }
    color() {
        if (this._color) {
            return this._color;
        }
        return 'rgba(19,64,238,0.4)';
    }
    predicate(value) {
        return (value & ZTCStateFlags.CONNECTION_VIA_WIFI) != 0;
    }
    // @ts-ignore
    extract_data(raw_data) {
        return raw_data?.status_flags;
    }
}
export class ZTCConnectionState_Ethernet extends ZTCGSMStateGraphSource {
    class_name() {
        return 'ZTCConnectionState_Ethernet';
    }
    title() {
        return 'Подключение Ethernet';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(197,16,39,0.4)';
    }
    predicate(value) {
        return (value & ZTCStateFlags.CONNECTION_VIA_ETHERNET) != 0;
    }
    // @ts-ignore
    extract_data(raw_data) {
        return raw_data?.status_flags;
    }
}
class ZTCGPSDataSource extends GraphSource {
    static gps_data_index = null;
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        if (ZTCGPSDataSource.gps_data_index == null) {
            console.error('ZTCGPSDataSource.gps_data_index is null');
            return null;
        }
        const index = ZTCGPSDataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
    data_source_key() {
        return LoadDataType.gps;
    }
    extract_data(raw_data) {
        return this._extract_from_gps(raw_data);
    }
    normalize_data(data) {
        return time_mul_1k(add_gaps(data));
    }
}
export class ZTCSpeedDataSource extends ZTCGPSDataSource {
    static gps_data_index = 3;
    class_name() {
        return 'ZTCSpeedDataSource';
    }
    title() {
        return 'скорость';
    }
    color() {
        if (this._color)
            return this._color;
        return '#103ca0';
    }
    yaxis_key() {
        return 'speed';
    }
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        const index = ZTCSpeedDataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
}
export class ZTCSatellitesDataSource extends ZTCGPSDataSource {
    static gps_data_index = 7;
    class_name() {
        return 'ZTCSatellitesDataSource';
    }
    title() {
        return 'количество спутников';
    }
    color() {
        if (this._color)
            return this._color;
        return '#c42467';
    }
    yaxis_key() {
        return 'count';
    }
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        const index = ZTCSatellitesDataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
}
export class ZTCHDOPDataSource extends ZTCGPSDataSource {
    static gps_data_index = 8;
    class_name() {
        return 'ZTCHDOPDataSource';
    }
    title() {
        return 'сигнал GPS';
    }
    color() {
        if (this._color)
            return this._color;
        return '#4da74d';
    }
    yaxis_key() {
        return 'percent-0-100';
    }
    _hdop2percent(hdop) {
        if (hdop != null)
            return (Math.max(0, 9 - hdop) * 100) / 9;
        return null;
    }
    normalize_data(data) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        data = super.normalize_data(...arguments);
        for (const item of data)
            item[1] = this._hdop2percent(item[1]);
        return data;
    }
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        const index = ZTCHDOPDataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
}
export class ZTCAltitudeDataSource extends ZTCGPSDataSource {
    static gps_data_index = 9;
    class_name() {
        return 'ZTCAltitudeDataSource';
    }
    title() {
        return 'высота';
    }
    color() {
        if (this._color)
            return this._color;
        return '#9440ed';
    }
    yaxis_key() {
        return 'meters';
    }
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        const index = ZTCAltitudeDataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
}
export class ZTCAvgVADataSource extends ZTCGPSDataSource {
    static gps_data_index = 10;
    class_name() {
        return 'ZTCAvgVADataSource';
    }
    title() {
        return 'среднее вертикальное ускорение';
    }
    color() {
        if (this._color)
            return this._color;
        return '#a05e19';
    }
    yaxis_key() {
        return 'acceleration';
    }
    _extract_from_gps(data) {
        if (JSON.stringify(data) === '{}') {
            return null;
        }
        const index = ZTCAvgVADataSource.gps_data_index;
        return data.map((item) => [item[0], item[index]]);
    }
}
export class ZTCWiFiLevelGraphSource extends GraphSource {
    class_name() {
        return 'ZTCWiFiLevelGraphSource';
    }
    title() {
        return 'уровень сигнала Wi-Fi';
    }
    color() {
        if (this._color) {
            return this._color;
        }
        return '#4300a8';
    }
    yaxis_key() {
        return 'dbm';
    }
    data_source_key() {
        return LoadDataType.ztc_state;
    }
    //@ts-ignore
    extract_data(raw_data) {
        return raw_data?.wifi_rssi;
    }
    normalize_data(data) {
        return cf
            .time_mul_1k(cf.normalize_time(data, 0))
            .map(([time, value]) => [time, value * -1]);
    }
}
